// driverDetails.js
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, FormControl, FormControlLabel, FormLabel, Grid2, IconButton, Modal, Paper, Radio, RadioGroup, Tab, Tabs, TextareaAutosize, Typography } from '@mui/material';
import Navbar from '../navbar/Navbar.jsx';
import Sidemenu from '../sidemenu/Sidemenu';
import './driverDetails.css';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import starIcon from '../../assets/icons/starIcon.png';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import defaultImg from '../../assets/images/defaultimg.png';
import altProfile from '../../assets/images/altProfile.png';
import verifiedTick from '../../assets/images/verifiedTick.png';
import rejectedCross from '../../assets/images/rejectedCross.png';
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import TokenError from '../tokenError.jsx';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import VisibilityIcon from '@mui/icons-material/Visibility';

function CustomTabPanel(props) {
    // console.log(props)
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }
  
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  
const DriverDetails = () => {

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [rows, setRows] = useState([]);
    const location = useLocation();
    const [value, setValue] = useState(0);
    const [driverDocumentsData, setDriverDocumentsData] = useState([]);
    const navigate = useNavigate();
    const [carDetailsData, setCarDetailsData] = useState([]);
    const [rejectModal, setRejectModal] = useState(false);
    const [rejectValue, setRejectValue] = useState('');
    const [customReason, setCustomReason] = useState('');
    const [modalData, setModalData] = useState({ vehicleId: null, documentId: null, status: 3, reason: '' });
    const [documentType, setDocumentType] = useState(''); 

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);

    const handleImageOpen = (image) => {
        setCurrentImage(image);
        setOpen(true);
    };

    const handleImageClose = () => {
        setOpen(false);
        setCurrentImage(null);
    };

    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
    
    const handleRejectChange = (event) => {
        setRejectValue(event.target.value);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
        // Fetch car details data when switching to the Documents tab (index === 0)
        if (newValue === 0) {
            fetchCarDetailsData();  // Call API when Documents tab is selected
        }
    };

    useEffect(() => {
        // Call the API when the component first mounts (page loads)
        fetchCarDetailsData();
    }, []);  

    const handleTextAreaChange = (event) => {
        setCustomReason(event.target.value);
    };
    const rowData = location.state?.rowData; // Access rowData from location state

    if (!rowData) {
        return <Typography>No data available</Typography>;
    }
    else{
        var driverName = rowData.driver_name;
        var driverId = rowData.driver_id;
        var driverPhone = rowData.phone_number;
        var driverEmail = rowData.email;
        var driverCity = (clientCities.find(city => city.city_id === rowData.city_id)) ? (clientCities.find(city => city.city_id === rowData.city_id)).city_name : '--';
            

        var driverImage = rowData.driver_image;
        var driverRating = parseFloat(rowData.rating).toFixed(2);
        var driverCurrentStatus = rowData.driver_current_status;
        var registeredDate = rowData.registered_date ? (rowData.registered_date).split('T')[0] : '--';
    }

    const fetchCarDetailsData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/driver/get_details`;
            const obj={
                token: token, timestamp: timestamp, driver_id: driverId,
            }

            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag == 200){
                const driversData = response.data;
                setCarDetailsData(driversData.vehicle_details)
                setDriverDocumentsData(driversData.driver_documents);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Handle reject modal open
    const handleRejectModal = (documentId, vehicleId, status, docType) => {
        setModalData({ documentId, vehicleId, status, docType});
        setRejectModal(true);
    };

    // Close reject modal
    const onClose = () => {
        setRejectModal(false);
        setRejectValue('');
        setCustomReason('');
    };

    const handleRejectSubmit = async (documentId, vehicleId, status, docType) => {

        try {
            const token = localStorage.getItem('token');
            const finalReason = customReason || rejectValue;
    
            // Check if it's a vehicle or driver document
            if (docType === 'vehicle') {
                console.log("Submitting Vehicle Document Approval/Rejection");

                // const url = `${operationsUrl}/vehicle/documents/verify`;
                // const obj={
                //     token: token,
                //     vehicle_id: vehicleId,   // Pass vehicle ID if it's a vehicle document
                //     document_id: documentId, // Pass document ID
                //     status: status,          // Pass the status (1 = approve, 3 = reject)
                //     reason: finalReason,     // Only include reason if it's a reject
                // }

                // const response =  await makePostRequestToUrl(url, obj);

                // console.log('response = ', response)

                const response = await axios.post(operationsUrl + '/vehicle/documents/verify', {
                    token: token,
                    vehicle_id: vehicleId,   // Pass vehicle ID if it's a vehicle document
                    document_id: documentId, // Pass document ID
                    status: status,          // Pass the status (1 = approve, 3 = reject)
                    reason: finalReason,     // Only include reason if it's a reject
                });

                if(response.data.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    console.log('toke====.....==== ', token);
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }
                if (response.status === 200) {
                    fetchCarDetailsData(); // Reload the data
                }
            } else if (docType === 'driver') {
                console.log("Submitting Driver Document Approval/Rejection");
                const response = await axios.post(operationsUrl + '/driver/documents/verify', {
                    token: token,
                    driver_id: driverId,           // Use the driver's ID
                    document_id: documentId,       // Pass document ID
                    status: status,                // Pass the status (1 = approve, 3 = reject)
                    reason: finalReason,           // Only include reason if it's a reject
                });
                if(response.data.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }
                if (response.status === 200) {
                    fetchCarDetailsData(); // Reload the data
                }
            }
        } catch (error) {
            console.error('Error handling approve/reject:', error);
        }
    };    

    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            <div style={{minHeight: '100vh'}}>
            
                <Typography style={{ fontSize: '28px', fontWeight: '500' }}>User</Typography>
                <Typography style={{ color: '#83888E'}}>User / Driver / Driver Details</Typography>

                <Grid2 className="mainBox">
                    <Grid2 container className="innerOne" size={12}>
                        <Grid2 item size={2} sx={{margin:'20px'}}>
                            <Box sx={{display:'flex'}}>
                                <Grid2>
                                    {driverImage && (
                                        <img className="profileBox" src={driverImage} alt="profile" width='80px' height='80px'/>
                                    )}
                                    {!driverImage && (
                                        <img className="profileBox" src={altProfile} alt="alt profile" width='80px' height='80px'/>
                                    )}
                                </Grid2>
                                
                            </Box>
                            <Typography sx={{mt:'4px'}}>{driverName}</Typography>
                            <Typography sx={{mt:'4px'}}>
                                {[...Array(5)].map((_, index) => (
                                    <span key={index}>
                                        {index < driverRating ? 
                                        <img src={starIcon} height="12px" width="12px" style={{marginRight:'1%'}} />
                                            : ' '}
                                    </span>
                                ))}
                                {/* <span style={{color:'#83888E', fontSize:'14px'}}>(50 reviews)</span> */}
                            </Typography>
                        </Grid2>
                        {/* <Grid2 item lg={3}></Grid2> */}
                        <Grid2 item size={9}>
                            <Grid2 container item sx={{marginTop:'24px', justifyContent:'flex-end'}}>
                                <Button
                                    variant="contained"
                                    style={{
                                        backgroundColor: driverCurrentStatus==0 ? '#F9E9E9' : '#E7F8F2',
                                        color: driverCurrentStatus==0 ? '#D14545' : '#0DBA78',
                                        textTransform: 'none',
                                        pointerEvents: 'none',
                                        borderRadius: '6px',
                                        minWidth: '60px',
                                        border:'none',
                                        boxShadow: 'none',
                                        fontFamily: 'Poppins',
                                        border: driverCurrentStatus==0 ? '1px solid #D14545' : '1px solid#36C68F',
                                        height:'24px'
                                    }}
                                >
                                    <FiberManualRecordIcon style={{ fontSize: '12px' }}/> {driverCurrentStatus == 0 ? 'Offline' : 'Online'}
                                </Button>
                            </Grid2>

                            <Grid2 container item spacing={6}  sx={{ marginTop:'46px', justifyContent:'right', marginBottom:'12px'}}>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Driver ID</Grid2>
                                    <Grid2 item className='detailsText'>{driverId}</Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Mobile Number</Grid2>
                                    <Grid2 item className='detailsText'>{driverPhone}</Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Email</Grid2>
                                    <Grid2 item className='detailsText'>{driverEmail}</Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Driver City</Grid2>
                                    <Grid2 item className='detailsText'>{driverCity}</Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Registered Date</Grid2>
                                    <Grid2 item className='detailsText'>{registeredDate}</Grid2>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Grid2>

                    <Grid2 container sx={{mt:'2%'}}>
                        <Box sx={{ width: '100%' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>
                                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{borderRadius:'12px'}}>
                                    <Tab sx={{
                                        textTransform:'none',
                                        color: value === 0 ? 'white' : '#83888E', // Directly set color here
                                        '&.Mui-selected': { color: 'white', borderBottom:'' },
                                        backgroundColor: value===0 ? '#0065FF' : '#E6F0FF', 
                                        borderRadius: '6px 0px 0px 6px', marginLeft:'1%', width: '120px'
                                    }} label="Document" {...a11yProps(0)} />

                                    <Tab sx={{
                                        textTransform:'none',
                                        color: value===1 ? 'white' : '#83888E',
                                        '&.Mui-selected': { color: 'white' },
                                        backgroundColor: value===1 ? '#0065FF' : '#E6F0FF', 
                                        borderRadius: '0px 6px 6px 0px', width: '120px'
                                    }} onClick={fetchCarDetailsData} label="Car Details" {...a11yProps(1)} />

                                    {/* <Tab sx={{
                                        textTransform:'none',
                                        color: value===2 ? 'white' : '#83888E',
                                        '&.Mui-selected': { color: 'white' },
                                        backgroundColor: value===2 ? '#0065FF' : '#E6F0FF', 
                                        borderRadius: value==2 ? '6px' : '0px',
                                        // borderBottom: value === 2 ? '2px solid' : 'none',
                                        margin: value===2 ? '4px' :'0px'
                                    }} label="Driver Trips" {...a11yProps(2)} /> */}
                                </Tabs>
                            </Box>

                            <CustomTabPanel value={value} index={0}>
                                <Grid2 container className="innerTwo" sx={{padding:'12px', marginTop:'2%'}}>
                                    <Grid2 item sx={{backgroundColor:'#F9F9F9', width:'100%', padding:'1%', borderRadius:'8px'}}>
                                        <Typography>Profile Picture</Typography>
                                    </Grid2>
                                    
                                    <Grid2 item size={9.5} sx={{marginLeft:'2%'}}>
                                        <Grid2 item container>
                                            <Grid2 item size={2} sx={{marginTop:'1%'}}>
                                                <Box height='102px' width='102px' sx={{borderRadius:'12px'}}>
                                                    {/* <img src={defaultImg} alt="signup img" width='100px' height='100px' /> */}
                                                    {driverImage && (
                                                        <img src={driverImage} alt="profile" width='100px' height='100px'/>
                                                    )}
                                                    {!driverImage && (
                                                        <img src={altProfile} alt="alt profile" width='100px' height='100px'/>
                                                    )}
                                                </Box>
                                            </Grid2>

                                            {/* upload button is commented for now */}
                                            {/* <Grid2 item size={9} sx={{marginTop:'3%'}}>
                                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>No Profile Picture Uploaded</Typography>
                                                <Button sx={{marginTop:'1%', border:1, borderColor:'#D1D5DB', borderRadius:'8px', textTransform:'none', color:'#83888E', width:'40%'}}>
                                                    <Typography>Upload</Typography>
                                                    <span style={{marginLeft:'auto'}}><NoteAddIcon/></span>
                                                </Button>
                                            </Grid2> */}
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                {/* code for documents is commented for now */}
                                <Grid2 container className="innerTwo" sx={{ padding: '12px', marginTop: '2%' }}>
                                    <Grid2 item sx={{ backgroundColor: '#F9F9F9', width: '100%', padding: '1%', borderRadius: '8px' }}>
                                        <Typography>Documents</Typography>
                                    </Grid2>

                                    <Grid2 item size={9.5} sx={{ marginLeft: '2%', mb: '2%' }}>
                                        {/* Loop through the driver documents */}
                                        {driverDocumentsData.map((doc, index) => (
                                            <Grid2 container sx={{ padding: '12px', marginTop: '2%' }} key={`driver-doc-${doc.document_id}-${index}`}>
                                                <Grid2 item sx={{ backgroundColor: '#F9F9F9', width: '100%', padding: '1%', borderRadius: '8px', display: 'flex' }}>
                                                    <Typography>{doc.document_name}</Typography>
                                                </Grid2>

                                                <Grid2 item size={9.5} sx={{ marginLeft: '2%', mb: '2%' }}>
                                                    {/* Document images */}
                                                    <Grid2 container spacing={10}>
                                                        {(doc.images.split(';;;;')).map((image, imageIndex) => (
                                                            <Grid2 
                                                                item 
                                                                size={2} 
                                                                sx={{ marginTop: '1%', textAlign: 'center' }} 
                                                                key={`driver-doc-${doc.document_id}-${imageIndex}`}
                                                            >
                                                                <Box 
                                                                    height='102px' 
                                                                    width='102px' 
                                                                    sx={{ 
                                                                        borderRadius: '12px', 
                                                                        overflow: 'hidden', 
                                                                        border: '2px solid #0065FF', 
                                                                        display: 'flex', 
                                                                        justifyContent: 'center', 
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    // onClick={() => handleImageOpen(image || defaultImg)}
                                                                >
                                                                    {image ? (
                                                                        <img src={image} alt={`doc image ${imageIndex}`} width='100%' height='100%' />
                                                                    ) : (
                                                                        <img src={defaultImg} alt="default image" width='100%' height='100%' />
                                                                    )}
                                                                </Box>

                                                                <Grid2>
                                                                    <VisibilityIcon sx={{
                                                                        cursor: 'pointer',marginTop: '8px',
                                                                        color: '#0065FF',fontSize: '24px'
                                                                        }} 
                                                                        onClick={() => handleImageOpen(image || defaultImg)}
                                                                    />
                                                                    {/* Label for Front and Back */}
                                                                    <Typography sx={{ marginTop: '4px', fontSize: '12px', color: '#83888E' }}>
                                                                        {imageIndex === 0 ? 'Front' : 'Back'}
                                                                    </Typography>
                                                                </Grid2>
                                                                
                                                            </Grid2>
                                                        ))}

                                                        {/* Modal for Image */}
                                                        <Modal open={open} onClose={handleImageClose}
                                                            sx={{display: 'flex',justifyContent: 'center',alignItems: 'center'}}>

                                                            <Box
                                                                sx={{
                                                                    position: 'relative', width: '90vw', height: '90vh',
                                                                    maxWidth: '500px', maxHeight: '500px', borderRadius: '12px',
                                                                    overflow: 'hidden', backgroundColor: 'white',
                                                                    display: 'flex',justifyContent: 'center', alignItems: 'center'
                                                                }}
                                                            >
                                                                <img
                                                                    src={currentImage}
                                                                    alt="Magnified Document"
                                                                    style={{maxWidth:'100%', maxHeight:'100%', objectFit:'contain'}}
                                                                />
                                                            </Box>
                                                        </Modal>

                                                        {/* Document status and reject/approve buttons */}
                                                        <Grid2 item size={7} sx={{ marginTop: '3%', marginLeft:'8%' }}>
                                                            {doc.status === 1 && (
                                                                <Grid2 item>
                                                                    <Grid2 item sx={{ marginBottom: '2%'}}>
                                                                        <img src={verifiedTick} width="36px" height="36px" alt="verified tick"/>
                                                                    </Grid2>
                                                                    <Grid2 item>
                                                                        <Typography sx={{ color: '#0DBA78', fontSize: '14px' }}>{doc.document_name} Approved</Typography>
                                                                    </Grid2>
                                                                </Grid2>
                                                            )}

                                                            {doc.status === 3 && (
                                                                <Grid2 item>
                                                                <Grid2 item sx={{marginBottom: '2%'}}>
                                                                    <img src={rejectedCross} width="36px" height="36px" alt="rejected cross"/>
                                                                </Grid2>
                                                                <Grid2 item>
                                                                    <Typography sx={{ color: '#C71F1F', fontSize: '14px' }}>{doc.document_name} Rejected</Typography>
                                                                    <Typography sx={{ color: '#83888E', fontSize: '14px' }}> (  {doc.reason}  )</Typography>
                                                                </Grid2>
                                                            </Grid2>
                                                            )}

                                                            {doc.status === 2 && (
                                                                <Grid2 container sx={{ gap: '8px', display: 'flex', marginTop:'4%' }}>
                                                                    <Grid2 item>
                                                                        <Button
                                                                            variant="contained"
                                                                            sx={{ backgroundColor: '#0DBA78', width: '120px' }}
                                                                            onClick={() => handleRejectSubmit(doc.document_id, null, 1, 'driver')} // Directly approve here
                                                                        >
                                                                            Approve
                                                                        </Button>
                                                                    </Grid2>
                                                                    <Grid2 item>
                                                                        <Button
                                                                            variant="contained"
                                                                            sx={{ backgroundColor: '#C71F1F', width: '120px' }}
                                                                            onClick={() => handleRejectModal(doc.document_id, null, 3, 'driver')}
                                                                        >
                                                                            Reject
                                                                        </Button>
                                                                    </Grid2>
                                                                </Grid2>
                                                            )}
                                                        </Grid2>
                                                    </Grid2>

                                                    
                                                </Grid2>
                                            </Grid2>
                                        ))}
                                    </Grid2>
                                </Grid2>
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={1}>
                                {(carDetailsData).map((vehicleDetails) => (
                                    <Grid2 sx={{bgcolor:'#F9F9F9', marginTop:'2%',padding:'1%', borderRadius:'16px'}}>
                                        <Grid2 container className="innerOne" sx={{ bgcolor:'#fff'}}>
                                            <Grid2 item sx={{margin:'20px'}}>
                                                <Box sx={{display:'flex'}}>
                                                    <Grid2>
                                                        {vehicleDetails.vehicle_image && (
                                                            <img  src={vehicleDetails.vehicle_image} alt="profile" width='120px' height='120px'/>
                                                        )}
                                                        {!vehicleDetails.vehicle_image && (
                                                            <img  src={defaultImg} alt="alt profile" width='120px' height='120px'/>
                                                        )}
                                                    </Grid2>
                                                </Box>
                                            </Grid2>

                                            <Grid2 sx={{marginTop:'auto', marginRight:'18px', ml:'18px', mb:"3%"}}>
                                                <Grid2 sx={{mb:'2%', mt:'2%'}}>
                                                    {/* <Typography>Maruti Swift Dzire ( {vehicleDetails.vehicle_id} )</Typography> */}
                                                    <Typography>Vehicle Details</Typography>
                                                </Grid2>
                                                <Grid2 container item spacing={10}>
                                                    <Grid2 item>
                                                        <Grid2 item className='detailsHead'>Status</Grid2>
                                                        <Grid2 item className='detailsText' style={{color: vehicleDetails.status === 1 ? '#0DBA78' : vehicleDetails.status === 0 ? '#F5BB19' : '#D14545'}}>
                                                            {vehicleDetails.status==1 ? 'Approved' : vehicleDetails.status==0 ? 'Pending' : 'Rejected'}
                                                        </Grid2>
                                                    </Grid2>
                                                    <Grid2 item>
                                                        <Grid2 item className='detailsHead'>Vehicle Number</Grid2>
                                                        <Grid2 item className='detailsText'>{vehicleDetails.vehicle_no}</Grid2>
                                                    </Grid2>
                                                    <Grid2 item>
                                                        <Grid2 item className='detailsHead'>Vehicle Type</Grid2>
                                                        <Grid2 item className='detailsText'>
                                                            {vehicleDetails.vehicle_type === 1 ? 'Taxi' : vehicleDetails.vehicle_type === 2 ? 'Bike' : vehicleDetails.vehicle_type === 3 ? 'Auto' : 'Unknown'}
                                                        </Grid2>
                                                    </Grid2>
                                                    {/* <Grid2 item>
                                                        <Grid2 item className='detailsHead'>Seats</Grid2>
                                                        <Grid2 item className='detailsText'>
                                                            {vehicleDetails.vehicle_type === 1 ? 4 : vehicleDetails.vehicle_type === 2 ? 1 : vehicleDetails.vehicle_type === 3 ? 3 : 'Unknown'}
                                                        </Grid2>
                                                    </Grid2>
                                                    <Grid2 item>
                                                        <Grid2 item className='detailsHead'>Fuel Type</Grid2>
                                                        <Grid2 item className='detailsText'>Petrol</Grid2>
                                                    </Grid2>
                                                    <Grid2 item>
                                                        <Grid2 item className='detailsHead'>Transmission</Grid2>
                                                        <Grid2 item className='detailsText'>Manual</Grid2>
                                                    </Grid2> */}
                                                </Grid2>
                                            </Grid2>
                                        </Grid2>
                                    
                                        {(vehicleDetails.document_details).map((doc, index) => (
                                            <Grid2 container sx={{ padding: '12px', marginTop: '2%' }} key={`vehicle-doc-${doc.document_id}-${index}`}>
                                            <Grid2 item sx={{ backgroundColor: '#fff', width: '100%', padding: '1%', borderRadius: '8px', display: 'flex' }}>
                                                <Typography sx={{display: 'flex', alignItems: 'center', height: '100%'}}>{doc.document_name}</Typography>
                                                <Grid2 item sx={{marginLeft:'auto'}}>
                                                    <Typography sx={{color:'#0065FF', border:'1px solid #D1D5DB', borderRadius:'6px', padding:'3px 8px'}}>{doc.document_number}</Typography>
                                                </Grid2>
                                                
                                            </Grid2>

                                            <Grid2 item size={9.5} sx={{ marginLeft: '2%', mb: '2%' }}>
                                                {/* Document images */}
                                                <Grid2 item container>
                                                    {(doc.images.split(';;;;')).map((image, imageIndex) => (
                                                        <Grid2 
                                                            item 
                                                            size={2} 
                                                            sx={{ marginTop: '1%', textAlign: 'center' }} 
                                                            key={`driver-doc-${doc.document_id}-${imageIndex}`}
                                                        >
                                                            <Box 
                                                                height='102px' 
                                                                width='102px' 
                                                                sx={{ 
                                                                    borderRadius: '12px', 
                                                                    overflow: 'hidden', 
                                                                    border: '2px solid #0065FF', 
                                                                    display: 'flex', 
                                                                    justifyContent: 'center', 
                                                                    alignItems: 'center'
                                                                }}
                                                                // onClick={() => handleImageOpen(image || defaultImg)}
                                                            >
                                                                {image ? (
                                                                    <img src={image} alt={`doc image ${imageIndex}`} width='100%' height='100%' />
                                                                ) : (
                                                                    <img src={defaultImg} alt="default image" width='100%' height='100%' />
                                                                )}
                                                            </Box>
                                                            <Grid2 item>
                                                                <VisibilityIcon sx={{
                                                                    cursor: 'pointer',marginTop: '8px',
                                                                    color: '#0065FF',fontSize: '24px'
                                                                    }} 
                                                                    onClick={() => handleImageOpen(image || defaultImg)}
                                                                />
                                                                {/* Label for Front and Back */}
                                                                <Typography sx={{ marginTop: '4px', fontSize: '12px', color: '#83888E' }}>
                                                                    {imageIndex === 0 ? 'Front' : 'Back'}
                                                                </Typography>
                                                            </Grid2>
                                                            
                                                        </Grid2>
                                                    ))}

                                                    {/* Modal for Image */}
                                                    <Modal open={open} onClose={handleImageClose}
                                                        sx={{display: 'flex',justifyContent: 'center',alignItems: 'center'}}>

                                                        <Box
                                                            sx={{
                                                                position: 'relative', width: '90vw', height: '90vh',
                                                                maxWidth: '500px', maxHeight: '500px', borderRadius: '12px',
                                                                overflow: 'hidden', backgroundColor: 'white',
                                                                display: 'flex',justifyContent: 'center', alignItems: 'center'
                                                            }}
                                                        >
                                                            <img
                                                                src={currentImage}
                                                                alt="Magnified Document"
                                                                style={{maxWidth:'100%', maxHeight:'100%', objectFit:'contain'}}
                                                            />
                                                        </Box>
                                                    </Modal>

                                                    {/* Document status and reject/approve buttons */}
                                                    <Grid2 item  sx={{ marginTop: '3%', marginLeft:'8%' }}>
                                                        {doc.status === 1 && (
                                                            <Grid2 item>
                                                                <Grid2 item sx={{ marginBottom: '2%', justifyItems:'center'}}>
                                                                    <img src={verifiedTick} width="36px" height="36px" alt="verified tick" style={{display:'flex'}} />
                                                                </Grid2>
                                                                <Grid2 item>
                                                                    <Typography sx={{ color: '#0DBA78', fontSize: '14px' }}>{doc.document_name} Approved</Typography>
                                                                </Grid2>
                                                            </Grid2>
                                                            // <Typography sx={{ color: '#0DBA78', fontSize: '14px' }}>Document Approved</Typography>
                                                        )}

                                                        {doc.status === 3 && (
                                                            <Grid2 item>
                                                                <Grid2 item sx={{marginBottom: '2%', justifyItems:'center' }}>
                                                                    <img src={rejectedCross} width="36px" height="36px" alt="rejected cross" style={{display:'flex'}} />
                                                                </Grid2>
                                                                <Grid2 item>
                                                                    <Typography sx={{ color: '#C71F1F', fontSize: '14px' }}>{doc.document_name} Rejected</Typography>
                                                                    <Typography sx={{ color: '#83888E', fontSize: '14px' }}> (  {doc.reason}  )</Typography>
                                                                </Grid2>
                                                            </Grid2>
                                                            // <Typography sx={{ color: '#C71F1F', fontSize: '14px' }}>Document Rejected</Typography>
                                                        )}

                                                        {doc.status === 2 && ( // If document status is "Pending"
                                                            <Grid2 container sx={{ gap: '8px', display: 'flex' }}>
                                                                {/* Approve Button */}
                                                                <Grid2 item>
                                                                    <Button
                                                                        variant="contained"
                                                                        sx={{ backgroundColor: '#0DBA78', width: '120px' }}
                                                                        onClick={() => handleRejectSubmit(doc.document_id, vehicleDetails.vehicle_id, 1, 'vehicle')} // Directly call handleRejectSubmit with status 1 for approval
                                                                    >
                                                                        Approve
                                                                    </Button>
                                                                </Grid2>

                                                                {/* Reject Button */}
                                                                <Grid2 item>
                                                                    <Button
                                                                        variant="contained"
                                                                        sx={{ backgroundColor: '#C71F1F', width: '120px' }}
                                                                        onClick={() => handleRejectModal(doc.document_id, vehicleDetails.vehicle_id, 3, 'vehicle')} // Open the reject modal with status 3
                                                                    >
                                                                        Reject
                                                                    </Button>
                                                                </Grid2>
                                                            </Grid2>
                                                        )}
                                                    </Grid2>
                                                </Grid2>

                                                
                                            </Grid2>
                                        </Grid2>
                                        ))}

                                    </Grid2>
                                ))}
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={2}>
                                {/* Item Three */}
                            </CustomTabPanel>
                        </Box>
                    </Grid2>
                </Grid2>


                {rejectModal && (
                    <>
                        {/* Backdrop Overlay */}
                        <div 
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 999,  // Make sure the overlay is below the modal
                            }}
                            onClick={onClose} // Close modal if clicked anywhere outside the modal
                        />
                        
                        {/* Modal */}
                        <div style={{
                            position: 'fixed', top:'4px', right:0, height:'100%',
                            width: '580px',
                            zIndex: 1000,
                            backgroundColor: '#F9F9F9',
                            // marginLeft: '58%',
                            padding: '2%',
                            height: '100vh',
                            borderRadius: '12px',
                        }}>
                            <IconButton
                                aria-label="close"
                                onClick={onClose}
                                style={{
                                    position: 'absolute',
                                    top: '-15px',
                                    left: '1px',
                                    color: '#333',
                                    zIndex: 10,
                                    paddingTop: '18px'
                                }}
                            >
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>

                            <Typography variant="body1" sx={{ color: '#4A4A4A', paddingTop: '6%', fontSize: '24px' }}>
                                Select Reason
                            </Typography>

                            <Grid2 style={{ maxWidth: '580px', margin: '0', backgroundColor: '#FFFFFF', borderRadius: '12px' }}>
                                <div style={{
                                    alignItems: 'center',
                                    backgroundColor: '#fff',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    marginTop: '30px'
                                }}>
                                    <Typography
                                        variant="body1"
                                        style={{
                                            color: '#1A1E25',
                                            fontWeight: '500',
                                            fontSize: '20px',
                                            paddingLeft: '4%'
                                        }}
                                    >
                                        Select Reason
                                    </Typography>

                                    <FormControl sx={{ marginLeft: '20px', marginTop: '2%' }}>
                                        <RadioGroup
                                            defaultValue=""
                                            name="controlled-radio-buttons-group"
                                            value={rejectValue}
                                            onChange={handleRejectChange}
                                        >
                                            <FormControlLabel sx={{ fontSize: '16px' }} value="Wrong Document" control={<Radio />} label="Wrong Document" />
                                            <FormControlLabel sx={{ fontSize: '16px' }} value="Image not clear" control={<Radio />} label="Image not clear" />
                                            <FormControlLabel sx={{ fontSize: '16px' }} value="other" control={<Radio />} label="Other" />
                                        </RadioGroup>
                                    </FormControl>

                                    <div style={{ marginLeft: '20px', marginTop: '18px' }}>
                                        <textarea
                                            name="Outlined"
                                            value={customReason}
                                            onChange={handleTextAreaChange}
                                            placeholder="Type in here…"
                                            style={{
                                                width: '90%',
                                                height: '100px',
                                                borderRadius: '8px',
                                                padding: '10px',
                                                borderColor: '#D1D5DB'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginTop: '18px', textAlign: 'center' }}>
                                        <Button
                                            variant='contained'
                                            className='actionButton'
                                            sx={{ ml: '4%', backgroundColor: '#C71F1F' }}
                                            onClick={() => {
                                                handleRejectSubmit(modalData.documentId, modalData.vehicleId, modalData.status, modalData.docType, customReason ? customReason : rejectValue);
                                                onClose(); // Close modal after rejection
                                            }}
                                            disabled={!customReason && !rejectValue}
                                        >
                                            Reject
                                        </Button>
                                    </div>

                                </div>
                            </Grid2>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default DriverDetails;
